// src/hooks/usePageTracking.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export default function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        if (/^\/tribute\/manage\/?$/i.test(location.pathname)) return;
    // Log a page view whenever the location changes
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location]);
}
